// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.switch_qbvQp {
  position: relative;
  display: inline-block;
  width: 40px;
  margin-top: 7px;
  height: 24px;
}

.switch_qbvQp input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider_FBZUa {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--c-background);
  transition: 0.4s;
  border-radius: 24px;
}

.slider_FBZUa:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 2px;
  bottom: 2px;
  background-color: var(--white-background);
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider_FBZUa {
  background-color: var(--_16c098-background);
}
input:checked + .bgBlack_HqMVC {
  background-color: #000000;
}

input:checked + .slider_FBZUa:before {
  transform: translateX(16px);
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/OptionsSwichComponent/optionsSwitch.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;AAC7C;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".switch {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  margin-top: 7px;\n  height: 24px;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--c-background);\n  transition: 0.4s;\n  border-radius: 24px;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 20px;\n  width: 20px;\n  left: 2px;\n  bottom: 2px;\n  background-color: var(--white-background);\n  transition: 0.4s;\n  border-radius: 50%;\n}\n\ninput:checked + .slider {\n  background-color: var(--_16c098-background);\n}\ninput:checked + .bgBlack {\n  background-color: #000000;\n}\n\ninput:checked + .slider:before {\n  transform: translateX(16px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"switch": `switch_qbvQp`,
	"slider": `slider_FBZUa`,
	"bgBlack": `bgBlack_HqMVC`
};
export default ___CSS_LOADER_EXPORT___;
